import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ICoords } from 'src/app/core/models/interfaces/coords';
import { IGenericResponse } from 'src/app/core/models/interfaces/i-generic-response';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LocationService } from 'src/app/core/services/location.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { environment } from 'src/environments/environment';

declare var google;

@Component({
  selector: 'find-field',
  templateUrl: './find-field.component.html',
  styleUrls: ['./find-field.component.scss'],
})
export class FindFieldComponent extends BaseModal implements OnInit {
  @Input() type: string;
  @Input() isFilizMode: boolean = false;
  phase: "options" | "search" | "list" = "options"
  optionsList = ["draw_farm", "parcel_inquiry", "saved_list"]
  searchList: Array<any> = [];
  fieldList: Array<any> = [];
  isLocationAvailable: boolean = true;
  isLocatedInTurkey: boolean = false;
  constructor(
    private modalService: ModalService,
    private farmApiService: FarmApiService,
    private loadingService: LoadingService,
    private locationService: LocationService,
    private translate: TranslateService) {
    super()
    super._modalService = modalService;
  }

  ngOnInit() {
    // this.locationService.GetMyCurrentLocation().then(e => {
    //   this.isLocationAvailable = LocationService.isLocationAvailable;
    // });
    LocationService.GetLocationFromIp().then(ipResponse => {
      if (ipResponse.country_code.toLowerCase() === 'tr') {
        this.isLocatedInTurkey = true;
      }
      else {
        this.phase = "search"
      }
    }).catch(err => {
      this.isLocatedInTurkey = true;
    })
    if (this.type == "import-field") {
      this.selectType("saved_list");
    }
  }
  previousPhase() {
    if (this.isLocatedInTurkey)
      this.phase = "options"
    else {
      this.dismiss(null)
    }
  }

  selectType(item) {
    switch (item) {
      case "draw_farm":
        this.phase = "search";
        break;
      case "saved_list":
        this.phase = "list";
        this.getFarmList();
        break;
      case "parcel_inquiry":
        this.dismiss({}, "startParcelInquiry");
        break;
    }
  }

  selectField(farm) {
    var y: number = +environment.campaignId;
    if (farm.CampaingId == y || +farm.CampaingId == 195) {
      this.dismiss(farm, "addDevice");
    } else {
      this.dismiss(farm, "importFarm");
    }
  }

  getFarmList() {
    this.loadingService.showLoading();
    this.farmApiService.getSharingFarmList(this.isFilizMode).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.fieldList = res.Data;
      }
    });
  }

  onSearchChange(ev) {
    let query = ev.detail.value;
    this.farmApiService.Geocoding(query, this.translate.currentLang).subscribe(e => {
      this.searchList = e.features;
    });
  }

  flyLocation(center) {
    let latlng: IGenericResponse<ICoords> = {
      IsSuccess: true,
      Message: "",
      StatusCode: 200,
      Data: {
        latitude: center[1],
        longitude: center[0]
      }
    }
    this.farmApiService.data = latlng;
    this.dismiss(latlng, "drawLocationSelected");
  }

  flyMyLocation() {
    // this.loading.showLoading();
    PermissionService.CheckAndRequestLocation(
      {
        granted: (ev) => {
          LocationService.GetMyCurrentLocation().then(response => {
            this.isLocationAvailable = LocationService.isLocationAvailable;
            this.loadingService.hideLoading();
            this.farmApiService.data = response
            this.dismiss(response, "drawLocationSelected")
          }).catch(err => {
            this.loadingService.hideLoading();
            LocationService.GetLocationFromIp().then(ipData => {
              let data: IGenericResponse<GeolocationCoordinates> = { Data: { accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, latitude: ipData.latitude, longitude: ipData.longitude, speed: 0 }, IsSuccess: true, Message: "", StatusCode: 200 }
              this.dismiss(data, "drawLocationSelected")
            })
          })
        },
        rejected: (err) => {
          this.isLocationAvailable = false
          PermissionService.instanceOfService.permissionDeniedAlert("location")
          // LocationService.GetLocationFromIp().then(ipData => {
          //   let data: IGenericResponse<GeolocationCoordinates> = { Data: { accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, latitude: ipData.latitude, longitude: ipData.longitude, speed: 0 }, IsSuccess: true, Message: "", StatusCode: 200 }
          //   // this.dismiss(data, "drawLocationSelected")
          // })

        }
      })

  }
  // flyMyLocation() {
  //   this.loadingService.showLoading();
  //   this.locationService.GetMyCurrentLocation().then(response => {
  //     this.isLocationAvailable = LocationService.isLocationAvailable;
  //     this.loadingService.hideLoading();
  //     let data = response.Data;
  //     this.farmApiService.data = response;
  //     this.dismiss(response, "drawLocationSelected");
  //   }).catch(err => {
  //     this.loadingService.hideLoading();
  //     LocationService.GetLocationFromIp().then(ipData => {
  //       let data = { accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, latitude: ipData.latitude, longitude: ipData.longitude, speed: 0 } as GeolocationCoordinates
  //       this.dismiss(data, "drawLocationSelected")
  //     })
  //   })
  // }
}
